/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Copy, Group, BodyCopy, Title, Form, SelectableList } from '@insticator/insticator-ui'; // iui-material
import PaymentInfoCTAs from 'pages/dashboard/account/paymentinfo/paymentInfoCTAs/paymentInfoCTAs_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/paymentinfo/selectmethod/selectmethod_styles';



/* ========== ~~~~~~~~~~ ACCOUNT SELECT PAYMENT METHOD ~~~~~~~~~~ ========== */
const SelectMethod = (props) => {

    const continueToEnterInfo = () => {
        if (props.selectedPaymentType === 'NONE') {
            props.sendErrorMessage('You need to select a payment type before moving forward.');
        } else {
            props.setFormEditableState(props.formName, true);
            props.moveToPage(`dashboard/account/paymentinfo/enterinformation`)
        }
    };

    const handleMoveBack = () => props.moveToPage(`dashboard/account/paymentinfo`);

    const typeSaved = (type) => props.savedPaymentTypes.includes(type);

    return (
        <div className={`selectmethod ${props.classes.selectmethod}`}>
            <Copy name={`page-copy`}>
                <Title variant={'withctas'}>
                    <h2>Payment Information </h2>
                    <Group name={`controls`}>
                        <PaymentInfoCTAs secondaryAction={handleMoveBack} secondaryButtonText={'Back'} primaryButtonText={'Continue'} primaryAction={continueToEnterInfo} />
                    </Group>
                </Title>
                <BodyCopy>
                    <p>Select a Payment Method</p>
                </BodyCopy>
            </Copy>
            <Group name={`page-details`}>
                <SelectableList type={'fancyradio'}
                    items={[{ value: 'PAYPAL', text: 'Paypal' },
                    { value: 'CHECKS', text: 'Check (US Only)' },
                    { value: 'ACH', text: 'Direct Deposit / ACH (US only)' },
                    { value: 'WIRE', text: 'Wire Transfer (international payment method)' }]}
                    selected={props.selectedPaymentType}
                    disabled={props.savedPaymentTypes.includes('CHECK') ? ['CHECKS', ...props.savedPaymentTypes] : props.savedPaymentTypes}
                    handleChange={(value) => props.changePaymentType(value)} />
            </Group>
        </div>
    );
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SelectMethod);
